import "./index.scss";
import unsubscribeImg from "../../assets/img/unsubscribe-image.gif";

export default function Resubscribe() {
  return (
    <section className="page-section  ">
      <div className="container p-3" style={{ minHeight: "calc(100vh)" }}>
        <div className="d-flex justify-content-center unsubscribe-animation">
          <img alt="" src={unsubscribeImg} />
        </div>

        <div className="message-body ">
          <h4>
            <b className="mb-2">سلام دوباره!</b>
          </h4>
          <p style={{ textAlign: "justify" }}>
            از اینکه ارتباطتون رو باهامون قطع نکردید، بی‌نهایت خوشحالیم. بزن
            بریم تا یادگیری رو شروع کنیم!
          </p>
          <div className="d-flex justify-content-center">
            {" "}
            <a className="btn btn-primary " href="zabanshenas://home/">
              <buttpn className="btn btn-primary">برو به زبانشناس</buttpn>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
